import React from 'react';
import { useTranslate } from 'hooks/useTranslate';
import ArticlesEndpoint from 'endPoints/articles';
import PageLayout from 'layouts/ListPage';
import Filters from 'pages/Posts/components/Filters';
import CardTemplate from 'pages/Posts/components/CardTemplate';

const Posts = () => {
  const t = useTranslate('HELMET');
  const breadcrumbs = React.useMemo(() => {
    return [
      {
        label: 'Home',
        link: '/'
      },
      {
        label: 'Posts'
      }
    ];
  }, []);

  return (
    <PageLayout
      endPoint={ArticlesEndpoint}
      translate={'Posts'}
      breadcrumbs={breadcrumbs}
      innerPage={'articles'}
      includeHreflang={true}
      Filters={Filters}
      CardTemplate={CardTemplate}
      meta={{
        title: t('postsTitle'),
        description: t('postsDescription'),
        ogTitle: t('postsOgTitle'),
        ogDescription: t('postsOgDescription')
      }}
    />
  );
};

export default Posts;
